import React, { Fragment, useState } from "react";
import { Modal, Row, Col, Spinner } from "react-bootstrap";
import styled from "styled-components";
import {
    CustomInput,
    CustomButton,
    CustomFormik,
} from "components/CustomForm";
import { MdClose } from "react-icons/md";
import { useMutation, useQuery } from "react-query";
import { changePassword } from 'network/apis/LoginApi';
import { toast } from "react-toastify";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { getErrorMessage } from "helpers/strings";

const ModalHolder = styled(Modal)`
  font-family: "YEKAN-BAKH-MEDIUM";
`;

const Header = styled.div`
  font-size: 18pt;
  width: 100%;
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

const FormHolder = styled(Form)`
  direction: rtl;
`;

const CloseButton = styled.div`
  background-color: #424250;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  top: 12px;
  right: 10px;
`;

const ChangePasswordModal = ({ isOpen, onClose, onCreateSuccess, data, ...rest }) => {
    const [loading, setLoading] = useState(false);

    const unitMutation = useMutation(changePassword, {
        onSuccess: (res) => {
            if (res && res.data) {
                toast(`با موفقیت ویرایش گردید`, {
                    type: "success",
                    position: "bottom-right",
                });
                onCreateSuccess?.();
                onClose();
            }
        },
        onError: (err) => {
            toast(getErrorMessage(err), {
                type: "error",
                position: "bottom-right",
            });
        },
        onSettled: () => {
            setLoading(false);
        },
    });

    return (
        <ModalHolder
            show={isOpen}
            size={"lg"}
            centered
            animation={false}
            onHide={onClose}
            {...rest}
        >
            <Modal.Body className="px-5">
                <CloseButton onClick={onClose}>
                    <MdClose color="#fff" />
                </CloseButton>
                <Header>
                    <span>تغییر رمز عبور کاربر</span>
                </Header>
                <Formik
                    initialValues={{
                        name: data?.name ?? "",
                        amount: data?.amount,
                        is_default: false,
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.new_password) {
                            errors.new_password = 'ضروری';
                        } else if (!values.confirm_password || values.confirm_password != values.new_password) {
                            errors.confirm_password = 'پسورد ها مطابقت ندارند';
                        }
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setLoading(true);
                        unitMutation.mutate({
                            user_id: data?.user_id,
                            current_password: '',
                            ...values
                        });
                    }}
                >
                    {({ isSubmitting, submitForm }) => (
                        <FormHolder>
                            <Fragment>
                                <div className="d-flex justify-content-between mb-2 w-100">
                                    <Col md={6} className="ps-1">
                                        <Field type="password" name="new_password">
                                            {({
                                                field,
                                                meta: { touched, error }
                                            }) => <CustomInput
                                                    className={touched && error ? "invalid" : ""}
                                                    {...field}
                                                    placeholder='رمز عبور جدید'
                                                    type='password'
                                                />
                                            }
                                        </Field>
                                        <ErrorMessage name="new_password" component="div" />
                                    </Col>
                                    <Col md={6} className="pe-1">
                                        <Field type="password" name="confirm_password">
                                            {({
                                                field,
                                                meta: { touched, error }
                                            }) => <CustomInput
                                                    className={touched && error ? "invalid" : ""}
                                                    {...field}
                                                    placeholder='تکرار رمز عبور'
                                                    type='password'
                                                />
                                            }
                                        </Field>
                                        <ErrorMessage name="confirm_password" component="div" />
                                    </Col>
                                </div>
                                <div className="d-flex justify-content-center mt-4 mb-3 w-100">
                                    <CustomButton
                                        className="ms-3 w-25"
                                        color="#7300FF"
                                        fontSize={16}
                                        onClick={onClose}
                                    >
                                        انصراف
                                    </CustomButton>
                                    <CustomButton
                                        fontSize={16}
                                        onClick={submitForm}
                                        disabled={loading}
                                        className="w-25 d-flex align-items-center justify-content-center"
                                    >
                                        {loading ? (
                                            <Spinner animation="border" role="status" size="sm" />
                                        ) : (
                                            <span>اعمال</span>
                                        )}
                                    </CustomButton>
                                </div>
                            </Fragment>
                        </FormHolder>
                    )}
                </Formik>
            </Modal.Body>
        </ModalHolder>
    );
};

export default ChangePasswordModal;
